(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bravora-megamenu"] && !Shopify.designMode) return;
  try {
    

(() => {

  const navItems = document.querySelectorAll('#bravora-header .bm-nav__item[data-bm-menu]');

  const mms = document.querySelectorAll('#bravora-header .bm-mm');

  const byId = (id) => document.getElementById(id);

  let closeTimer = null;

  let openKey = null;



  const closeAll = () => {

    mms.forEach(m => m.classList.remove('is-open'));

    navItems.forEach(i => i.classList.remove('is-open'));

    openKey = null;

  };

  const open = (key) => {

    const tgt = byId(`bm-mm-${key}`);

    if (!tgt) return closeAll();

    if (openKey && openKey !== key) byId(`bm-mm-${openKey}`)?.classList.remove('is-open');

    tgt.classList.add('is-open');

    navItems.forEach(i => i.classList.toggle('is-open', i.dataset.bmMenu === key));

    openKey = key;

  };

  const cancelClose = () => { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } };

  const scheduleClose = () => { cancelClose(); closeTimer = setTimeout(closeAll, 180); };



  navItems.forEach(item => {

    const key = item.dataset.bmMenu;

    item.addEventListener('mouseenter', () => { cancelClose(); open(key); });

    item.addEventListener('mouseleave', scheduleClose);

    item.querySelector('a')?.addEventListener('focus', () => open(key));

  });

  mms.forEach(p => {

    p.addEventListener('mouseenter', cancelClose);

    p.addEventListener('mouseleave', scheduleClose);

  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });



  /* Ocultar al bajar, mostrar al subir (cualquier movimiento hacia arriba revela).

     Aplicamos sobre #header-group (hijo de <body>, altura completa) para que la

     stickiness no se "suelte" al bajar mucho. Fallback a #bravora-header. */

  const header = document.getElementById('header-group') || document.getElementById('bravora-header');

  let lastY = Math.max(0, window.scrollY);

  let ticking = false;

  const DOWN_THRESHOLD = 6;   /* px hacia abajo antes de ocultar */

  const TOP_RANGE = 60;       /* cerca del top: siempre visible */



  const updateHeader = () => {

    const y = Math.max(0, window.scrollY);

    const diff = y - lastY;

    if (Math.abs(diff) > 20 && openKey) closeAll();

    if (header) {

      if (y < TOP_RANGE || diff < 0) {

        header.classList.remove('is-hidden');   /* arriba del todo o subiendo -> mostrar */

      } else if (diff > DOWN_THRESHOLD) {

        header.classList.add('is-hidden');       /* bajando -> ocultar */

      }

    }

    lastY = y;

    ticking = false;

  };



  window.addEventListener('scroll', () => {

    if (!ticking) {

      requestAnimationFrame(updateHeader);

      ticking = true;

    }

  }, { passive: true });



  /* Mobile drawer  ACCORDION */

  const drawer = byId('bm-drawer');

  const burger = document.querySelector('#bravora-header .bm-burger');

  const closeBtns = document.querySelectorAll('[data-bm-close]');

  const toggles = drawer?.querySelectorAll('.bm-drawer__toggle');



  const openDrawer = () => {

    if (!drawer) return;

    drawer.classList.add('is-open');

    drawer.setAttribute('aria-hidden', 'false');

    document.body.classList.add('bm-drawer-open');

    burger?.setAttribute('aria-expanded', 'true');

  };

  function closeDrawer() {

    if (!drawer) return;

    drawer.classList.remove('is-open');

    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('bm-drawer-open');

    burger?.setAttribute('aria-expanded', 'false');

  }



  burger?.addEventListener('click', openDrawer);

  closeBtns?.forEach(b => b.addEventListener('click', closeDrawer));



  /* Localization toggle */

  const locContainer = document.querySelector('.bm-localization');

  if (locContainer) {

    const locToggle = locContainer.querySelector('.bm-localization__toggle');

    const locPanel = locContainer.querySelector('.bm-localization__panel');

    locToggle?.addEventListener('click', (e) => {

      e.stopPropagation();

      const isOpen = !locPanel.hasAttribute('hidden');

      if (isOpen) {

        locPanel.setAttribute('hidden', '');

        locToggle.setAttribute('aria-expanded', 'false');

      } else {

        locPanel.removeAttribute('hidden');

        locToggle.setAttribute('aria-expanded', 'true');

      }

    });

    document.addEventListener('click', (e) => {

      if (!locContainer.contains(e.target)) {

        locPanel.setAttribute('hidden', '');

        locToggle.setAttribute('aria-expanded', 'false');

      }

    });

    locContainer.querySelectorAll('select').forEach(sel => {

      sel.addEventListener('change', (e) => e.target.form.submit());

    });

  }



  // Accordion: toggle is-open en cada bm-drawer__item

  toggles?.forEach(toggle => {

    toggle.addEventListener('click', () => {

      const item = toggle.closest('.bm-drawer__item');

      const isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open', !isOpen);

      toggle.setAttribute('aria-expanded', !isOpen);

    });

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* ============================================================
     GHOST BLOCKS — shuffle coordinado de testimonios.
     - Cada rotator = 1 bloque C en la página.
     - Renderizamos los 5 testimonios y aquí escogemos cuál mostrar.
     - Estado global: si en la página hay 2 bloques C, NUNCA muestran
       el mismo testimonio (mientras haya >= 2 quotes disponibles).
     - El MutationObserver re-aplica cuando infinite scroll appendea
       nuevos rotators (página 2, 3...).
     ============================================================ */
  (function() {
    const usedIndexes = new Set();
    let availableCount = 0;

    function shuffleOne(rotator) {
      if (rotator.dataset.shuffled === '1') return;
      const items = rotator.querySelectorAll('.ghost-block__quote');
      if (!items.length) return;
      availableCount = Math.max(availableCount, items.length);
      if (items.length === 1) {
        rotator.dataset.shuffled = '1';
        return;
      }

      // Pool of indexes NOT yet used in this page session
      const candidates = [];
      for (let i = 0; i < items.length; i++) {
        if (!usedIndexes.has(i)) candidates.push(i);
      }
      // If exhausted (more rotators than testimonios), restart pool
      if (candidates.length === 0) {
        usedIndexes.clear();
        for (let i = 0; i < items.length; i++) candidates.push(i);
      }

      const pickIdx = candidates[Math.floor(Math.random() * candidates.length)];

      // Hide all, show only picked
      for (let k = 0; k < items.length; k++) {
        items[k].classList.add('ghost-block__quote--hidden');
      }
      items[pickIdx].classList.remove('ghost-block__quote--hidden');
      usedIndexes.add(pickIdx);
      rotator.dataset.shuffled = '1';
    }

    function applyAll(root) {
      const scope = root || document;
      const rotators = scope.querySelectorAll('.ghost-block__quote-rotator:not([data-shuffled="1"])');
      rotators.forEach(shuffleOne);
    }

    // Initial pass on first paint
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => applyAll(), { once: true });
    } else {
      applyAll();
    }

    // Watch for new rotators appended by infinite scroll
    const grid = document.querySelector('.product-grid');
    if (grid && 'MutationObserver' in window) {
      const mo = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.ghost-block__quote-rotator')) {
              shuffleOne(node);
            } else if (node.querySelectorAll) {
              const inner = node.querySelectorAll('.ghost-block__quote-rotator:not([data-shuffled="1"])');
              inner.forEach(shuffleOne);
            }
          });
        });
      });
      mo.observe(grid, { childList: true, subtree: true });
    }
  })();

  /* B15-F6 metal swatch image swap: delegación resistente a filtros/Ajax. */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(
      '.product-grid .variant-option__swatch[data-metal-bucket][data-brv-metal-image-url]'
    );
    if (!swatch) return;
    const card = swatch.closest('product-card');
    const image = card?.querySelector(
      '.card-gallery slideshow-slide[aria-hidden="false"] img, .card-gallery slideshow-slide img, .card-gallery img'
    );
    const isUrl = (u) => /^(https?:)?\/\//.test(String(u || '').trim());
    const src = swatch.dataset.brvMetalImageUrl;
    // BRAVORA 20-09-2026: nunca escribir en src algo que no sea una URL. Si la variante no
    // tiene foto, Liquid puede dejar un texto de error en el data-attr -> card rota.
    if (!(image instanceof HTMLImageElement) || !isUrl(src)) return;
    const srcset = swatch.dataset.brvMetalImageSrcset;
    if (srcset && isUrl(srcset)) image.srcset = srcset;
    image.src = src;
  });


  } catch(e) { console.error(e); }
})();
})();
